<table class="table table-eddy" *ngIf="lista && lista.length > 0">
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td style="width: 100%;">
        <div class="d-flex flex-column align-items-start justify-content-center">
          <span [class]="'mb-1 badge badge-' + globalService.corTipoContato(item.tipo)" style="font-size: 8.5px;">
            {{globalService.tituloTipoContato(item.tipo)}}
          </span>
          <p *ngIf="item.tipo === 'TE' && !item.editavel" class="m-0">{{item.contato | TELEFONE}}</p>
          <p *ngIf="item.tipo !== 'TE' && !item.editavel" class="m-0">{{item.contato}}</p>
          <input *ngIf="item.tipo === 'TE' && item.editavel"
            [imask]="{mask: [  {mask: '(00) 0000-0000'}, {mask: '(00) 00000-0000'} ]}" unmask="true"
            [(ngModel)]="item.contato" type="text" class="form-control form-control-sm">
          <input *ngIf="item.tipo !== 'TE' && item.editavel" [(ngModel)]="item.contato" type="text"
            class="form-control form-control-sm">
        </div>
        <div class="row mt-1 mb-1">
          <div class="col-sm-6">
            <div class="checkbox checbox-switch switch-success">
              <label>
                <input type="checkbox" [ngModel]="item.principal" [disabled]="disabledPrincipal(item)"
                  (click)="salvarItem(item)" /><span></span>Principal
              </label>
            </div>
          </div>
          <div class="col-sm-6">
            <button *ngIf="!item.editavel" (click)="remover(item, idx)" [disabled]="disabled()"
              class="btn btn-sm btn-outline-primary float-right">
              <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
            </button>
            <button *ngIf="!item.editavel" (click)="editar(item)" [disabled]="disabled()"
              class="btn btn-sm btn-outline-primary mr-2 float-right">
              <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
            </button>
            <button *ngIf="item.editavel" (click)="cancelar(item, idx)"
              class="btn btn-sm btn-outline-primary float-right">
              <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
            </button>
            <button *ngIf="item.editavel" (click)="salvar(item)"
              class="btn btn-sm btn-outline-secondary mr-2 float-right">
              <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
            </button>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>